import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetDjuYearSiteSchemaResponse = z.array(
  z.object({
    siteName: z.string(),
    siteId: numberOrStringToNumberSchema,
    djuYears: z.array(z.number()),
  }),
)

export type GetDjuYearSiteResponse = z.infer<typeof GetDjuYearSiteSchemaResponse>
